import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CountriesQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type CountriesQueryResult = { __typename?: 'Query' } & {
  countries?: GraphQLTypes.Maybe<Array<{ __typename?: 'Country' } & Pick<GraphQLTypes.Country, 'code' | 'name'>>>;
};

export const CountriesDocument = gql`
  query countries {
    countries {
      code
      name
    }
  }
`;
